import _ from 'lodash'
import { actions } from '../../../store/features/featuresSlice'
import { FeaturesByAvailability, FeatureValues } from '../../../store/features/types'
import { FeedbotThunk } from '../../../store/types'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { FeatureAvailability } from '../../../store/features/featuresSchema'

export function close(): FeedbotThunk {
  return dispatch => {
    dispatch(modalsActions.closeModal())
  }
}

export function save(featuresByAvailability: FeaturesByAvailability): FeedbotThunk {
  return dispatch => {
    const availabilityGroups = Object.values(FeatureAvailability)
    const featuresFlat: FeatureValues = _.merge(
      {},
      ...availabilityGroups.map(group => featuresByAvailability[group])
    )

    dispatch<any>(actions.setFeatureValues({ set: 'userSettings', values: featuresFlat }))
    dispatch<any>(close())
  }
}
